/*
    This file is part of Universal Sequencer.
    Universal Sequencer is free software: you can redistribute it and/or modif
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Universal Sequencer is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import React, { Component } from 'react';
import ConditionedComponent from 'components/ConditionedComponent.js';
import ReactTooltip from 'react-tooltip'
import { connect } from "react-redux";
import {WAVEFORM, INFO} from 'constants/arrangement-modes.js';
import {
    setSelectedSampleTag,
    setSampleDragging,
    setContextualHelp} from "actions/index.js";
import {TRACK_THUMBNAIL} from 'constants/contextual-help.js';
import PulseLoader from 'react-spinners/PulseLoader'
import { Badge} from 'reactstrap';
import ipfs from 'decentralized/Ipfs.js';
import axios from 'axios';
import Colors from 'components/Colors.js';

const colors = new Colors();
class YoutubeInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            thumbnail: '',
            name: props.name,
            videoId: props.sample.videoId,
        };
        this.apiKey = "AIzaSyCf2k8RM7tFFlVGo4CVPvCsOhx86vWwTT0";
        this.getYoutubeTitle.bind(this);
        this.getYoutubeThumbnail.bind(this);

        let videoId = this.props.sample.videoId;
        if (videoId !== undefined && videoId !== '') {
            this.getYoutubeThumbnail(videoId);
        }

        if (this.props.coverArt) {
            this.getDiscogsThumbnail(this.props.coverArt);
        }

        if (this.props.sample.coverArtHash) {
            this.getDiscogsThumbnail(this.props.sample.coverArtHash);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        let ret = false;
        if (nextProps.showingWaveform !== this.props.showingWaveform) {
            ret = true;
        }

        if (nextProps.id !== this.props.id) {
            ret = true;
        }
        if (nextProps.selectedSampleTag !== this.props.selectedSampleTag) {
            ret = true;
        }
        if (nextProps.sample.soundId !== this.props.sample.soundId ||
            nextProps.sample.ipfsHash !== this.props.sample.ipfsHash) {
            ret = true;
        }

        if (nextProps.name != this.state.name) {
            this.state.name = nextProps.name;
            ret = true;
        }

        if (nextProps.isCompactMode !== this.props.isCompactMode) {
            ret = true;
        }
        
        if (nextProps.videoId !== this.props.videoId) {
            this.getYoutubeThumbnail(nextProps.videoId);
            ret = true;
        }

        if (nextProps.sample.videoId !== this.state.videoId) {
            this.state.videoId = nextProps.sample.videoId;
            //this.getYoutubeTitle(getLink(nextProps.videoId));
            this.getYoutubeThumbnail(this.state.videoId);
            ret = true;
        } 

        if (nextProps.coverArt !== this.props.coverArt) {
            this.getDiscogsThumbnail(nextProps.coverArt);
            ret = true;
        }

        if (nextProps.sample.coverArtHash !== this.props.sample.coverArtHash) {
            this.getDiscogsThumbnail(nextProps.sample.coverArtHash);
            ret = true;
        }

        if (nextProps.sample !== undefined && nextProps.name !== undefined) {
            this.state.name = nextProps.name;
        }

        if (nextState.thumbnail !== this.state.thumbnail) {
            ret = true;
        }

        if (nextProps.isLoading !== this.props.isLoading) {
            ret = true;
        }

        return ret;
    }

    getYoutubeTitle(url) {
        if (url === undefined ||
            url === null ||
            url === '') {
            this.setState(this.state);
            return;
        }

        var splits = url.split("=");
        var self = this;
        if (splits.length > 1) {
            var videoId = splits[splits.length - 1];
            if (videoId === '') {
                this.state.name = this.props.name;
                this.setState(this.state);
                return;
            }
            axios.get(
                      "https://www.googleapis.com/youtube/v3/videos?id=" + videoId + "&key="+ this.apiKey + "&fields=items(snippet(title))&part=snippet")
                .then((data) => self.setState({'name': data.data.items[0] !== undefined ? this.truncateName(data.data.items[0].snippet.title) : 'Video deleted'}));
        }
    }

    getDiscogsThumbnail(hash) {
        this.state.thumbnail = ipfs.getHashUrl(hash);
        this.setState(
            this.state
        );
    }

    getYoutubeThumbnail(videoId) {
        if (videoId === '' || videoId === undefined) {
            this.state.thumbnail = '';
            this.setState(this.state);
            return;
        }
        var url = 'https://img.youtube.com/vi/' + videoId + '/1.jpg';
        var state = this.state;
        state['thumbnail'] = url;
        this.setState(state);
    }

    onClickTag(tag) {
        if (tag === this.props.selectedSampleTag) {
            this.props.setSelectedSampleTag(this.props.sample.getId(), undefined);
        } else {
            this.props.setSelectedSampleTag(this.props.sample.getId(), tag);
        }
    }

    onImgError() {
        this.setState({thumbnail: ''});
    }

    getTags() {
        if (this.props.selectedSampleTag !== undefined) {
            return [this.props.selectedSampleTag];
        }

        if (this.props.isCompactMode && this.props.sample.tags.length > 0) {
            return [this.props.sample.tags[0]];
        }
        return this.props.sample.tags;
    }

    truncateName(str) {
        if (str === undefined || str === null) {
            return null;
        }
        let truncateLength = this.props.isCompactMode ? 14 : maxNameLength;
        let x = str.length > truncateLength? str.substring(0, truncateLength) + '...' : str;
        return x.trim();
    }

    onDragOver(e) {
        e.stopPropagation();
    }

    onDragStart(e) {
        this.props.setSampleDragging(this.props.sample);
    }

    setContextualHelp(e, help) {
        e.stopPropagation(e);
        this.props.setContextualHelp(help);
    }


    render() {
        let big = this.props.isBig ? 'big ' : '';

        if (this.props.showingWaveform && this.props.track) {
            big += " showing-waveform ";
        }

        if (this.props.isCompactMode) {
            big += ' compact ';
        }

        let style = {};
        if (this.state.thumbnail === '') {
            if (this.props.track) {
                style = {
                    backgroundColor: colors.getColorForTrack(this.props.track)
                };
            } else {
                let stringToConvert = this.props.sample.getId() !== undefined ? 
                    this.props.sample.getId() :
                    this.props.name !== undefined ? this.props.name :
                    'other instrument';
                style = {
                    backgroundColor: colors.saturate(
                        colors.getColorForHash(stringToConvert), 3)
                };
            }
        }

        let contextualHelp = this.props.contextualHelp || TRACK_THUMBNAIL;
        return (
            <div
              className='youtube-info'>
              <div>
                  {this.props.showDelete ? <div className="delete-button delete-track-button" onClick={this.props.onClickDelete}>x</div> : '' }
                  {this.state.thumbnail === '' ?
                      <div
                            draggable={true}
                            onDragStart={(e) => this.onDragStart(e)}
                            onDragOver={(e) => this.onDragOver(e)}
                            onMouseOver={(e) => this.setContextualHelp(e, contextualHelp)}
                        onMouseLeave={() => this.props.setContextualHelp(undefined)}
                        className={big + 'sound-thumbnail'}
                        style={style}
                            onClick={this.props.onClickThumbnail}>
                            <PulseLoader
                                  className="track-loading-spinner"
                                  sizeUnit={"px"}
                                  size={10}
                                  color={'white'}
                                  loading={this.props.isLoading}
                                  />
 
                          </div>
                          :
                        <img
                            draggable={true}
                            onDragStart={(e) => this.onDragStart(e)}
                            onDragOver={(e) => this.onDragOver(e)}
                              onMouseOver={(e) => this.setContextualHelp(e, contextualHelp)}
                          onMouseLeave={() => this.props.setContextualHelp(undefined)}
                          onError={() => this.onImgError()}
                          className={this.props.isMuted ? big + "muted youtube-thumbnail" : big + "youtube-thumbnail"}
                          onClick={this.props.onClickThumbnail}
                          src={this.state.thumbnail}/>}
                </div>
              <ConditionedComponent condition={!this.props.hideName}>
                <div className='youtube-name'>
                  <span onClick={this.props.onClickName}>{this.truncateName(this.state.name)}</span>
                </div>
              </ConditionedComponent>
               {this.props.children}
                </div>);
    }
}

function getLink(videoId) {
    return "https://www.youtube.com/watch?v=" + videoId;
}


const maxNameLength = 36;
const mapDispatchToProps = (dispatch, props) => {
    return {
        setSelectedSampleTag: (id, tag) => dispatch(setSelectedSampleTag(id, tag)),
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
        setSampleDragging: (sample) => dispatch(setSampleDragging(sample)),
    };
};

const mapStateToProps = (state, props) => {
    let selectedSampleTag = state.tracks.selectedSampleTags[props.sample.getId()];
    let track = props.track;
    if (track && track.tracks && track.tracks[0]) {
        track = track.tracks[0].track;
    }
    return {
        id: track === undefined ? 0 :
            track.sample !== undefined && track.sample.getId() !== undefined ?
            track.sample.getId() : track.presetName || track.getName(),
        selectedSampleTag: selectedSampleTag,
        isCompactMode: state.sequencer.isCompactMode && !props.isBig,
        showingWaveform: state.sequencer.showPianoRoll &&
            (state.arrangement.bottomMode === WAVEFORM ||
             state.arrangement.bottomMode === INFO),
        isLoading: props.track === undefined ? false :
            state.tracks.trackIsLoading[props.track.subSequence.id] ?
            state.tracks.trackIsLoading[props.track.subSequence.id][props.track.trackNumber] === true : false,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(YoutubeInfo);
